import { axios } from '../../services/axios';

const getPartnerList = async (wholesalerId, currentScope) => {
    const res = axios.get(`/partners/${wholesalerId}`, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });

    return res;
};

export default getPartnerList;
